module.exports = __webpack_public_path__ + "static/media/IMG-8.96cdb6a4.jpg";